import NotificationPreferencesEditor from '@koob/profile/src/components/NotificationPreferencesEditor';
import { useAsync } from 'react-async';
import { KoobButton } from '@koob/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnack } from '../../../hooks';
import {
  getUserNotificationPreferences,
  updateUserNotificationPreferences,
} from '../../../api/users';

export default function ProfileNotificationPreferences({ userId }) {
  const { t } = useTranslation('misc');
  const { notify } = useSnack();

  const [preferences, setPreferences] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const { isLoading } = useAsync({
    promiseFn: getUserNotificationPreferences,
    userId: userId,
    onResolve: response => setPreferences(response?.data || []),
  });

  const updatePreferences = async () => {
    setIsSaving(true);

    try {
      const newPreferences = await updateUserNotificationPreferences(
        userId,
        preferences,
      );
      setPreferences(newPreferences.data);
      notify('Notification preferences updated successfully');
    } catch (error) {
      notify('Failed to update notification preferences', { type: 'error' });
      console.error('Failed to update notification preferences:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <NotificationPreferencesEditor
        loading={isLoading}
        preferences={preferences}
        setPreferences={setPreferences}
      />

      <div className="mt-3 flex justify-end">
        <KoobButton
          variant="primary"
          onClick={updatePreferences}
          loading={isLoading || isSaving}
        >
          {t('save')}
        </KoobButton>
      </div>
    </div>
  );
}
